import { Box, Card, Link, Typography } from '@mui/material';
import { useFromQueryParam } from '../../helpers/getFromQueryParam';
import NotFoundImage from '../../assets/images/not_found.png';

function NotAccessPage() {
    const from = useFromQueryParam();
    return (
        <Card style={{ textAlign: 'center', padding: '30px 20px', borderRadius: '25px' }}>
            <img src={NotFoundImage} style={{ maxWidth: 150 }} alt="logo" />
            <Typography variant="h2" fontSize={18} mt={3} mb={1} px={3}>
                アクセス権限がありません。
            </Typography>
            {from !== 'app' && (
                <Box mt={3}>
                    <Link
                        fontSize={22}
                        underline="hover"
                        href={`${window.location.origin}/login`}
                        onClick={() => {
                            localStorage.removeItem('token');
                        }}
                        style={{
                            fontWeight: 700
                        }}
                    >
                        TOPページへ
                    </Link>
                </Box>
            )}
        </Card>
    );
}

export default NotAccessPage;
